module.exports = __webpack_public_path__ + "static/media/2022 - 2023 theme logo.b696843b.jpeg";